import { data } from '@free-cutyapple/d';

export const log = () => {
  console.log(data);
};
